import styled from 'styled-components';

import colors from 'styles/colors';

export const HeaderBarStyled = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 24px;
  margin-bottom: 16px;
  min-width: 0;
  width: 100%;

  h2 {
    margin: 0;
    padding: 0;
    width: 100%;
    font-weight: 600;
    font-size: 22px;
    line-height: 1.5;
    color: ${colors.brand_2};
  }
`;
